import { css } from 'styled-components';

export const KMRApparat = css`
  @font-face {
    font-family: 'KMR Apparat';
    font-weight: 300; /* Light */
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'KMR Apparat';
    font-weight: 400; /* Regular */
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'KMR Apparat';
    font-weight: 500; /* Book */
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'KMR Apparat';
    font-weight: 600; /* Medium */
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'KMR Apparat';
    font-weight: 700; /* Bold */
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'KMR Apparat';
    font-weight: 800; /* Heavy */
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'KMR Apparat';
    font-weight: 900; /* Black */
    font-style: normal;
    font-display: swap;
  }
`;
